import { FastField } from "formik"
import { TextField } from "formik-material-ui"
import React from "react"

export const IdentificationNumberField = (props: any) => {
  return (
    <FastField
      style={{
        width: "100%",
      }}
      component={TextField}
      id="info.identificationNumber"
      name="info.identificationNumber"
      type="text"
      label="Rodné číslo"
    ></FastField>
  )
}
